import api from '../api';

export const fetchMessages = (data) => api.post('/core/functions/fetchMessages', data);

export const sendMessage = (data) => api.post('/messages/send', data);
